// 月額コース登録処理をまとめたカスタムフック
import { useMutation } from '@tanstack/react-query'
import { useAtom } from 'jotai'
import { useNavigate } from 'react-router-dom'
import { accessIdAtom, accessTokenAtom, payStartUrlAtom, payTypeAtom } from '@!/atoms/paymentAtom'
import { registerMonthlyCourseApi as registerMonthlyCourseWithCreditApi, registerMonthlyCourseWithPayApi } from '@!/Api/monthlyCourse'
import { useAppCookies } from '@!/Hooks'
import { isBlank } from '@!/Util'

export const useMonthlyCourseRegister = () => {
  const navigate = useNavigate()
  const [, setAccessId] = useAtom(accessIdAtom)
  const [, setAccessToken] = useAtom(accessTokenAtom)
  const [, setPayStartUrl] = useAtom(payStartUrlAtom)
  const [, setPayType] = useAtom(payTypeAtom)
  const { setLastMonthlyCoursePayTypeCookie } = useAppCookies()

  const handleSuccess = (data, variables) => {
    setAccessId(data.access_id)
    setAccessToken(data.token)
    setPayStartUrl(data.redirect_url)
    setPayType(variables.pay_type)
    setLastMonthlyCoursePayTypeCookie(variables.pay_type)

    if (isBlank(data.redirect_url)) {
      const { monthly_course_id, order_id, restore } = data
      const params = new URLSearchParams({ monthly_course_id, order_id, restore })
      window.location.href = `/static_page/monthly_course_registration_complete?${params.toString()}`
    } else {
      navigate('/redirect')
    }
  }

  const handleError = (error) => {
    const params = new URLSearchParams({ error: error.data?.error })
    window.location.href = `/static_page/monthly_course_registration_complete?${params.toString()}`
  }

  // クレジット決済
  const registerWithCredit = useMutation({
    mutationFn: (params) => registerMonthlyCourseWithCreditApi(params),
    onSuccess: handleSuccess,
    onError: handleError,
  })

  // キャリア決済・PayPay決済
  const registerWithPay = useMutation({
    mutationFn: (params) => registerMonthlyCourseWithPayApi(params),
    onSuccess: handleSuccess,
    onError: handleError,
  })

  const executeRegister = (payType, monthlyCourseId, restoreOrderId, restore) => {
    const params = {
      monthly_course_id: monthlyCourseId,
      restore_order_id: restoreOrderId,
      restore: restore,
      pay_type: payType,
    }
    if (payType === 'credit') {
      registerWithCredit.mutate(params)
    } else if (payType === 'docomo' || payType === 'au' || payType === 'paypay') {
      registerWithPay.mutate(params)
    }
  }

  return {
    executeRegister,
    isRegistering: registerWithCredit.isPending || registerWithPay.isPending,
    isRegisterError: registerWithCredit.isError || registerWithPay.isError,
  }
}
